// noinspection NpmUsedModulesInstalled

import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import '@fontsource/roboto';
import '@fontsource/roboto/700.css';
import reducer from '~/reducer';
import Application from '@/modules/application/components/Application';
import { initialState as initialDock } from '@/modules/application/reducers/dock';

const content = document.getElementById('content');

const cfg = JSON.parse(document.getElementById('cfg').textContent);
const auth = JSON.parse(document.getElementById('auth').textContent);

const store = createStore(
    reducer, {
        cfg: cfg,
        auth: auth,
        dock: initialDock,
    },
    applyMiddleware(thunk)
);

ReactDOM.render(<Provider store={store}><Application/></Provider>, content);
